module.exports = __webpack_public_path__ + "img/accordion.b454f335.svg";